export default "__VITE_ASSET__CV$V7sVv__"